import React, { useState } from "react";
import { useToast } from "@chakra-ui/react";
import ExportMenu from "../../../components/shared/ExportMenu";

import pako from "pako";
const Exports = ({ supplier, retailer, hideDiscontinued = false }) => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  const fetchCsvOriginal = async (vars, url, name) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(vars),
    };

    try {
      setIsLoading(true);
      const response = await fetch(url, requestOptions);
      setIsLoading(false);

      const contentType = response.headers.get("content-type");
      console.log("contentType: ", contentType);
      if (contentType && (contentType.includes("text/csv") || contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"))) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${name}_${vars.supplier}_${vars.retailer}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast({
          title: "Success",
          description: `${name} file downloaded successfully.`,
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        console.log("error", response);
        toast({
          title: "Error",
          description: "An error occurred while downloading the file.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setIsLoading(false);
      toast({
        title: "Technical Error",
        description: "A technical error occurred.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  const fetchCsv = async (vars, url, name) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(vars),
    };

    try {
      setIsLoading(true);
      const response = await fetch(url, requestOptions);
      setIsLoading(false);

      const contentType = response.headers.get("content-type");
      console.log("contentType: ", contentType);

      if (contentType) {
        if (contentType.includes("application/gzip")) {
          // Handle gzipped CSV file
          const blob = await response.blob();
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${name}_${vars.supplier}_${vars.retailer}.csv.gz`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          toast({
            title: "Success",
            description: `${name} zipped CSV file downloaded successfully.`,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        } else if (contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
          // Handle Excel file
          const blob = await response.blob();
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${name}_${vars.supplier}_${vars.retailer}.xlsx`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          toast({
            title: "Success",
            description: `${name} Excel file downloaded successfully.`,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        } else if (contentType.includes("text/csv")) {
          // Handle plain CSV file
          const blob = await response.blob();
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `${name}_${vars.supplier}_${vars.retailer}.csv`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          toast({
            title: "Success",
            description: `${name} CSV file downloaded successfully.`,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        } else {
          console.log("error", response);
          toast({
            title: "Error",
            description: "An error occurred while downloading the file.",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        }
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setIsLoading(false);
      toast({
        title: "Technical Error",
        description: "A technical error occurred.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const click_csv1 = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/rep_margin/csv1`;
      const name = `Margin Report`;
      // The Margin Report sheet mirrors the grid, so it must honour the same
      // toggle — otherwise the export silently contains lines the user hid.
      const vars = { supplier, retailer, userid: localStorage.getItem("userid"), hideDiscontinued };
      await fetchCsv(vars, url, name);
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  const click_priceList = async () => {
    try {
      setIsLoading(true);
      let priceListUrl = `${process.env.REACT_APP_API_URL}/rep_margin/priceList`;
      const response = await fetch(priceListUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ supplier }),
      });
      setIsLoading(false);
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `${supplier} Price List.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        toast({ title: "Success", description: "Price List downloaded successfully.", status: "success", duration: 5000, isClosable: true });
      } else {
        toast({ title: "Error", description: "An error occurred while downloading the file.", status: "error", duration: 5000, isClosable: true });
      }
    } catch (error) {
      console.error("Error fetching price list:", error);
      setIsLoading(false);
      toast({ title: "Technical Error", description: "A technical error occurred.", status: "error", duration: 5000, isClosable: true });
    }
  };

  return (
    <ExportMenu
      isLoading={isLoading}
      items={[
        { label: "Margin Report", onClick: click_csv1 },
        { label: `${supplier} Price List`, onClick: click_priceList },
      ]}
    />
  );
};

export default Exports;
